export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/christine-profile-7f57d528978666ca8b42a312ea938c7d.png";